module.exports = __webpack_public_path__ + "static/img/MA@3x.8e69421f.jpg";